import "@css/index.css";
import "@css/login.css";
import { images } from "@img/imagesMap";
import { NavLink } from "react-router-dom";
import { useLoginModalActions } from "@hooks/useLoginModal";

import { useLoginUser } from "@hooks/useAuth";
import { toast } from "@/components/toast/CustomToast";

function Index() {
  const loginUser = useLoginUser();
  // const isAdmin = useIsAdmin();
  const { setOpen } = useLoginModalActions();

  const canCreateRoster = !loginUser || loginUser.is_head_nurse;

  const menuBoxClass =
    "flex flex-col items-center bg-zinc-50! gap-y-[18px] bg-white rounded-[18px] py-8 px-4 shadow-[2px_2px_6px_0_rgba(0,0,0,0.2)] cursor-pointer";

  return (
    <div className="min-w-[1100px] grid grid-cols-1 grid-rows-1 [grid-template-areas:'contents'] overflow-hidden">
      <div className="[grid-area:contents] overflow-hidden relative">
        <video className="w-full h-full object-cover" autoPlay loop muted>
          <source src="/video/video_main_light.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="[grid-area:contents] z-[1] flex flex-col justify-center items-center gap-y-6">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="font-[family-name:var(--font-jalnan)] text-white text-[32px] flex items-start gap-x-[0.2em] [&_img]:h-[1em]"
        >
          <img src={images.logo_aide_white} alt="" />
          <span className="translate-y-[0.11em]">On:Maum</span>
          <img src={images.text_ai_white} alt="" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className=" font-[family-name:var(--font-jalnan)] text-[#0e59c6] text-[62px]  items-start gap-x-[0.2em] py-4 [&_img]:h-[1em]"
        >
          <span className="translate-y-[0.11em]">온:마음</span>
          <img src={images.text_ai_color} alt="" />
          <span className="translate-y-[0.11em]">근무표</span>
        </div>
        <div className="font-[family-name:var(--font-suit)] font-extrabold text-[#333] text-[30px]">
          "모든 마음을 모아, 마음을 ON 하다."
        </div>
        <div className="font-[family-name:var(--font-suit)] font-normal text-[#333] text-[30px]">
          함께 마음을 모아 더 좋은 근무환경을 만들어가자는 의미를 가지고
          있습니다.
        </div>

        <div className="grid grid-cols-[repeat(auto-fit,320px)] justify-center mt-4">
          {canCreateRoster &&
            (loginUser ? (
              <NavLink to="/Roster_create" className={menuBoxClass}>
                <img src={images.icon_service_roster} className="h-10" alt="" />
                <div className="flex justify-center items-center gap-x-[0.5em]">
                  <div className="font-[family-name:var(--font-jalnan)] text-[#1857a6] text-xl flex items-center gap-x-[0.2em] leading-none">
                    <img
                      src={images.logo_svg}
                      alt=""
                      className="h-[1em] object-contain align-top"
                    />
                    <span className="translate-y-[0.15em]">
                      온:마음{" "}
                      <span className="font-[family-name:var(--font-tenada)]">
                        AI
                      </span>
                    </span>
                  </div>
                  <span className="text-[28px] font-[family-name:var(--font-freesentation)] font-normal text-[#333]">
                    근무표 만들기
                  </span>
                </div>
              </NavLink>
            ) : (
              <div
                className={menuBoxClass}
                onClick={() => {
                  toast.warning("로그인이 필요한 서비스입니다.");
                  setOpen(true);
                }}
              >
                <img src={images.icon_service_roster} className="h-10" alt="" />
                <div className="flex justify-center items-center gap-x-[0.5em]">
                  <div className="font-[family-name:var(--font-jalnan)] text-[#1857a6] text-xl flex items-center gap-x-[0.2em] leading-none">
                    <img
                      src={images.logo_svg}
                      alt=""
                      className="h-[1em] object-contain align-top"
                    />
                    <span className="translate-y-[0.15em]">
                      온:마음{" "}
                      <span className="font-[family-name:var(--font-tenada)]">
                        AI
                      </span>
                    </span>
                  </div>
                  <span className="text-[28px] font-[family-name:var(--font-freesentation)] font-normal text-[#333]">
                    근무표 만들기
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
export default Index;
